import { useEffect, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FloatLabel } from "primereact/floatlabel";
import { Sidebar } from "primereact/sidebar";
import { TreeSelect } from "primereact/treeselect";

import { DisplayErrors } from "../../../Utils/ErrorHandler";
import DropdownInput from "../Inputs/DropdownInput";
import { buildGroupHierarchy, getGroupCode } from "../../../Utils/Utils";
import useApi from "../../../Utils/BackendClient";

import commonStyle from "../../content/CommonStyles.module.css";
import { Button } from "primereact/button";
import QuantityPickerSidebar from "./QuantityPickerSidebar";

const RemainingPickerSidebar = ({ visible, onHide, isMobile, toast, formik, ctx, onProductPick, divisionField }) => {

    const [quantitySidebarVisible, setQuantitySidebarVisible] = useState(false);
    const [lazyState, setLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
        filters: {
            product_group: { value: null, matchMode: 'contains' },
            division: { value: null, matchmode: 'equals' }
        }
    });
    const [loading, setLoading] = useState(true);
    const [productGroups, setProductGroups] = useState(null);
    const [products, setProducts] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedRemaining, setSelectedRemaining] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);

    const { fetchProductsExtended, fetchRemainings } = useApi();

    useEffect(() => {

        const loadProductGroups = async () => {
            const response = await fetchProductsExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setProductGroups(groups);
            }
        }

        loadProductGroups();

    }, [fetchProductsExtended]);

    const GetProducts = async (state) => {
        const response = await fetchRemainings(state);

        if (response.status === 200) {

            setProducts(response.data.results);
            console.log(response.data.count);
            setTotalRecords(response.data.count);

            setLoading(false);
        }
        else {
            DisplayErrors(response.error, toast);
        }
    }

    const setProductGroupValue = (id) => {

        setLoading(true);
        setSelectedGroup(id);

        let filterGroup = getGroupCode(id);

        const newLazyState = lazyState;
        newLazyState.filters.product_group.value = filterGroup;
        newLazyState.filters.division.value ??= formik.values[divisionField];
        newLazyState.page = 1;
        newLazyState.first = 0;
        setLazyState(newLazyState);

        console.log(newLazyState);

        GetProducts(newLazyState);
    }

    const setDivision = (id) => {
        formik.setFieldValue(divisionField, id);

        const newLazyState = lazyState;
        newLazyState.filters.division.value = id;
        newLazyState.page = 1;
        newLazyState.first = 0;
        setLazyState(newLazyState);

        if (selectedGroup) {

            setLoading(true);
            GetProducts(newLazyState);
        }
    }

    const onProductsPage = (event) => {
        const newLazyState = event;
        newLazyState.page = event.page + 1;
        newLazyState.rows = event.rows;
        newLazyState.filters = lazyState.filters;

        setLazyState(newLazyState);

        setLoading(true);

        GetProducts(newLazyState);
    }

    const AddProductToTable = (quantity) => {
        setQuantitySidebarVisible(false)
        selectedRemaining.quantity = quantity;

        onProductPick(selectedRemaining);
        onHide();
        setSelectedRemaining(null);
    }

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xl text-900 font-bold">{tablename}</span>
            </div>
        );
    }

    const actionBodyTemplate = (rowData) => {

        const allItemsAreBooked = rowData.service_group === undefined && rowData.total_quantity === rowData.booked;

        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded ${allItemsAreBooked ? commonStyle.closeButton : commonStyle.addButton}`}
                disabled={allItemsAreBooked}
                tooltip={allItemsAreBooked ? "Товар використано в акті" : "Додати"}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => {
                    setSelectedRemaining(rowData);
                    setQuantitySidebarVisible(true);
                }}
            />
        </div>
        );
    };

    return (<>
        <Sidebar visible={visible} position="right" onHide={onHide} className={!isMobile ? `${commonStyle.sidebar} ${quantitySidebarVisible ? commonStyle.moveLeft : ''}` : "w-full"}>
            <div className="p-inputgroup flex-column mt-4">
                {formik.values[divisionField] === null && <label>Виберіть точку продажу для вибору товару</label>}
                {(selectedGroup === null && formik.values[divisionField]) && <label>Виберіть групу товарів для вибору товару</label>}
                <DropdownInput
                    formik={formik}
                    paramName={divisionField}
                    context={ctx.enums.divisions.data}
                    onChange={(val) => { setDivision(val) }}
                    label={"Точка продажу"}
                    isMobile={isMobile}
                    customStyle="w-full" />
                {formik.values[divisionField] && <div className="p-inputgroup flex-column mt-4">
                    <FloatLabel>
                        <TreeSelect
                            name="set_group"
                            value={selectedGroup}
                            onChange={(e) => setProductGroupValue(e.value)}
                            options={productGroups}
                            className="w-full" />
                        <label>Назва групи</label>
                    </FloatLabel>
                </div>}
            </div>
            {products && <DataTable className="mt-4" lazy value={products} header={setTableHeader("Товари")} rows={lazyState.rows} paginator onPage={onProductsPage}
                first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} emptyMessage="Залишків по групі не знайдено">
                <Column field="product_name" header="Назва продукту" />
                <Column field="total_quantity" body={(rowData) => rowData.total_quantity + "(" + rowData.booked + ")"} header="Кількість(резерв)" />
                <Column field="identifier" header="Ідентифікатор" />
                <Column field="action" body={actionBodyTemplate} />
            </DataTable>}
        </Sidebar>
        <QuantityPickerSidebar visible={quantitySidebarVisible} selectedRemaining={selectedRemaining} onHide={() => setQuantitySidebarVisible(false)} onSelect={(quantity) => AddProductToTable(quantity)} />
    </>);
}

export default RemainingPickerSidebar;